"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResolvedTags = exports.launchCustomIntegration = exports.convertSocialNetworkData = exports.getKeywordPredictiveSearchResults = exports.parseResume = exports.getApplyWithAuthUrl = exports.validateAnonymousEmail = exports.getCorpSettingValue = exports.submitApplication = exports.checkExternalJobApplicationCache = exports.getSavedApplication = exports.validateWorkflowPage = exports.getCareerCenterApplicationWorkflowPage = exports.getApplicationWorkflowPage = exports.shouldRedirectToResponsiveWorkflow = exports.getJobDetail = exports.getSiteData = exports.bootstrapCareerCenterApplication = exports.bootstrapCareerSiteApplication = void 0;
var api_1 = require("../api");
var application_1 = require("../models/application");
var apiServices = new api_1.ApiService();
var siteData = {
    header: {
        isAdvanced: false,
        html: '',
        color: '',
        imagePath: '',
        imageAlt: ''
    },
    footer: {
        isAdvanced: false,
        html: '',
        color: '',
        imagePath: '',
        imageAlt: ''
    },
    settings: {
        allowedLanguages: [],
        signInPath: "",
        signOutPath: "",
        createProfilePath: "",
        myProfilePath: "",
        showToolbar: true,
        currentLanguage: {
            cultureId: 1,
            cultureName: "en-US",
            isRightToLeft: false
        },
        mapsIsPremium: false,
        mapsApiKey: "",
    },
    searchBanner: {
        bannerImagePath: [],
        bannerHtml: ""
    },
    companyInformationHtml: "",
    jobDetailsBannerImagePath: ""
};
var jobDetail = {
    displayTitle: "",
    ref: "",
    jobAd: "",
    primaryLocation: {
        title: "",
        geocode: {
            latitude: "",
            longitude: ""
        }
    },
    additionalLocations: new Array()
};
exports.bootstrapCareerSiteApplication = function (careerSiteId, reqId, cultureId) {
    return Promise.all([
        apiServices.getCareerSiteData(careerSiteId, cultureId),
        apiServices.getJobDetail(reqId)
    ]).then(function (_a) {
        var _b;
        var careerSiteData = _a[0], jobDetailData = _a[1];
        siteData = Object.assign(siteData, careerSiteData);
        jobDetail = Object.assign(jobDetail, jobDetailData);
        jobDetail.displayTitle = (_b = jobDetail.displayTitle) !== null && _b !== void 0 ? _b : "";
    });
};
exports.bootstrapCareerCenterApplication = function (reqId, cultureId) {
    return apiServices.getJobDetail(reqId)
        .then(function (jobDetailData) {
        var _a;
        jobDetail = Object.assign(jobDetail, jobDetailData);
        jobDetail.displayTitle = (_a = jobDetail.displayTitle) !== null && _a !== void 0 ? _a : "";
    });
};
exports.getSiteData = function () {
    return Promise.resolve(siteData);
};
exports.getJobDetail = function () {
    return Promise.resolve(jobDetail);
};
exports.shouldRedirectToResponsiveWorkflow = function (requisitionId) {
    return Promise.resolve(apiServices.shouldRedirectToResponsiveWorkflow(requisitionId));
};
exports.getApplicationWorkflowPage = apiServices.getWorkflowPage.bind(apiServices);
exports.getCareerCenterApplicationWorkflowPage = apiServices.getCareerCenterWorkflowPage.bind(apiServices);
exports.validateWorkflowPage = function (actionsToValidate, requisitionId, page) {
    return Promise.resolve(apiServices.validateWorkflowPage(actionsToValidate, requisitionId, page));
};
exports.getSavedApplication = apiServices.getSavedApplication.bind(apiServices);
exports.checkExternalJobApplicationCache = apiServices.checkExternalJobApplicationCache.bind(apiServices);
exports.submitApplication = function (responses, requisitionId, careerSiteId, isCareerCenter, applicationId, qsParams) {
    return Promise.resolve(apiServices.submitApplication(responses, requisitionId, careerSiteId, isCareerCenter, applicationId, qsParams));
};
exports.getCorpSettingValue = function (key) {
    return apiServices.getCorpSettingValue(key);
};
exports.validateAnonymousEmail = function (email, requisitionId) {
    return Promise.resolve(apiServices.validateAnonymousEmail(email, requisitionId));
};
exports.getApplyWithAuthUrl = function (providerId, redirectUrl, careerSiteId, jobReqId) {
    return Promise.resolve(apiServices.getApplyWithAuthUrl(providerId, redirectUrl, careerSiteId, jobReqId));
};
exports.parseResume = function (resumeFileUploadToken, parsingType) {
    return Promise.resolve(apiServices.parseResume(resumeFileUploadToken, parsingType));
};
exports.getKeywordPredictiveSearchResults = function (searchRequest) {
    return apiServices.getKeywordPredictiveSearchResults(searchRequest).then(function (data) {
        var _a, _b;
        return ((_b = (_a = data === null || data === void 0 ? void 0 : data.searchCapabilities) === null || _a === void 0 ? void 0 : _a.pagedResult) === null || _b === void 0 ? void 0 : _b.map(function (item) { return new application_1.Skill({
            clustreeId: item.skillsGraphId,
            id: item.id,
            name: item.name
        }); })) || [];
    });
};
exports.convertSocialNetworkData = apiServices.convertSocialNetworkData.bind(apiServices);
exports.launchCustomIntegration = function (actionId, jobRequisitionId, cultureId, jobApplicationId, careerSiteId, isCareerCenter, email, firstName, lastName, contactDetails, redirectUrl, qsParams) {
    return Promise.resolve(apiServices.launchCustomIntegration(actionId, jobRequisitionId, cultureId, jobApplicationId, careerSiteId, isCareerCenter, email, firstName, lastName, contactDetails, redirectUrl, qsParams));
};
exports.getResolvedTags = function (userid, reqId, message) {
    var requestData = {
        UserId: userid,
        RequisitionId: reqId,
        Message: message
    };
    return Promise.resolve(apiServices.getResolvedTags(requestData));
};



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/mapping/index.ts
// module id = 38
// module chunks = 0 2